<template>
    <ul class="file-closet" :class="{left:position=='left'}">
        <li
            v-for="(item,index) in actionsWrap"
            :class="{disabled:item.disable||false}"
            @click.stop="action(index)"
            @mouseenter="active(item,index)"
            @mouseleave="deactive(item,index)"
            :key="index"
        >
            <div>
                <span class="icon">{{item.icon}}</span>
                <span class="action">{{`${$t(item.action)} ${tagAndNoteNum(index)}`}}</span>
                <span class="show-more icon">{{item.next==true?'\ue990':''}}</span>
            </div>
            <ul class="child-list" v-if="childListIndex.indexOf(index)!==-1" v-show="showList">
                <li>
                    <a @click.stop="moveToCase(-1)">{{$t('action.create-newcase')}}</a>
                </li>
                <div class="case-list">
                    <li
                        v-for="(c,index) in item.childList"
                        :key="index"
                        :class="{disabled:index==caseNowIn}"
                        @click.stop="moveToCase(index)"
                    >
                        <a>{{c}}</a>
                    </li>
                </div>
            </ul>
        </li>
    </ul>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        actions: {
            type: Array,
            default() {
                return [];
            }
        },
        caseNowIn: {
            type: Number,
            default: -1
        },
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        position: {
            type: String,
            default: "right"
        }
    },
    data() {
        return {
            nowSelect: -1,
            showList: false,
            childListIndex: []
        };
    },
    mounted() {
        let actions = this.actions;
        // push the index to the childListIndex if the action has child list
        for (let i in actions) {
            if (actions[i].next) {
                this.childListIndex.push(Number(i));
            }
        }
    },
    computed: {
        type() {
            return this.item["type"];
        },
        // add the attribute 'disable' to action
        actionsWrap() {
            let newActions = this.actions;
            if (this.type == "doc") {
                newActions[0].disable = this.item.notes.length == 0;
                newActions[1].disable = this.item.tags.length == 0;
            }
            return newActions;
        }
    },
    methods: {
        /**
         * trigger when hover action and if the action has next level then show child list
         * @param {object} item action object ({icon:icon,action:action,next:true})
         * @param {Number} index
         */
        active(item, index) {
            this.nowSelect = index;
            if (item.next) {
                this.showChildList();
            }
        },
        /**
         * get number of tags and notes
         * @param {Number} index index of view note or view tag action
         */
        tagAndNoteNum(index) {
            if (this.type == "doc") {
                switch (index) {
                    case 0:
                        return `(${this.item.notes.length})`;
                    case 1:
                        return `(${this.item.tags.length})`;
                }
            }
            return "";
        },
        /**
         * hide child list leave the action
         * @param {object} item
         * @param {Number} index
         */
        deactive(item, index) {
            if (item.next) {
                this.hideChildList();
            }
            this.nowSelect = -1;
        },
        showChildList() {
            this.showList = true;
        },
        hideChildList() {
            this.showList = false;
        },
        /**
         * select action
         * @param {Number} index index of the selected action
         */
        action(index) {
            this.$emit("actionSelect", index);
        },
        /**
         * select a case to move to
         * @param {Number} index index of the case in all cases
         */
        moveToCase(index) {
            this.$emit("moveToCase", index);
        }
    }
};
</script>

<style lang="scss" scoped>
.file-closet {
    position: absolute;
    min-width: 152px;
    background: $base-color;
    box-shadow: 0px 1px 7px -2px rgba(13, 36, 60, 1);
    border-radius: 0px 4px 4px 4px;
    left: 210px;
    top: 35px;
    padding: 5px 0;
    z-index: 100;
    transition: all 150ms;
    li {
        list-style: none;
        position: relative;
        &.disabled {
            & > div {
                span.icon,
                span.action {
                    color: $border-color;
                }
            }
            &:hover {
                background-color: $base-color;
            }
        }
        &:hover {
            background-color: $back-color;
        }
        .child-list {
            position: absolute;
            padding: 5px 0;
            top: 0;
            right: -3px;
            transform: translateX(100%);
            width: 152px;
            background: $base-color;
            box-shadow: 0px 1px 7px -2px rgba(13, 36, 60, 1);
            border-radius: 0px 4px 4px 4px;
            &::before {
                @include after;
                width: 3px;
                left: -3px;
                height: 100%;
            }
            & > li,
            .case-list > li {
                color: $light-purple;
                font-size: 14px;
                padding-left: 10px;
                height: 30px;
                list-style: none;
                &:first-child {
                    border-bottom: 1px solid $border-color;
                }
                &.disabled {
                    background-color: $base-color;
                    a {
                        color: $border-color;
                    }
                    &:hover {
                        background-color: $base-color;
                    }
                }
                &:hover {
                    background-color: $back-color;
                }
                &:first-child a {
                    display: inline-block;
                    width: 132px;
                    // border-bottom: 1px solid $border-color;
                }
                a {
                    color: $dark-purple;
                    font-size: 14px;
                    line-height: 30px;
                    width: 90%;
                    display: inline-block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .case-list {
                max-height: 90px;
                overflow-y: scroll;
                & > li:first-child {
                    border-bottom: none;
                }
            }
        }
    }
    li > div {
        @include flex;
        justify-content: flex-start;
        height: 30px;
        span.icon {
            display: inline-block;
            width: 30px;
            text-align: center;
            color: $dark-purple;
        }
        span.action {
            white-space: nowrap;
            font-size: 14px;
            line-height: 30px;
            color: $dark-purple;
        }
        span.show-more {
            color: $light-purple;
        }
        span:last-child {
            margin-left: auto;
        }
    }
    &.left {
        left: auto;
        right: 0;
        top: 30px;
        li .child-list {
            transform: translateX(-100%);
            left: -3px;
            right: auto;
            &::before {
                right: -3px;
                left: auto;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/fileCloset.vue